import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface IConfirmationButtonsProps {
	handleConfirm?: () => void;
	handleCancel?: () => void;
	disabled?: boolean;
}

const ConfirmationButtons: React.FC<IConfirmationButtonsProps> = ({
	handleConfirm,
	handleCancel,
	disabled,
}) => {
	return (
		<>
			<Tooltip title="Confirm">
				<button
					className={` !w-[40px] h-[40px] p-[10px] pl-[11px] border-transparent border-[1px] 
                      hover:shadow-sm hover:border-[#ECEDEF] hover:border-[1px] 
                      focus:shadow-sm focus:border-[#ECEDEF] focus:border-[1px] confirm
                      ${disabled && 'cursor-progress'}
                      `}
					onClick={handleConfirm}
					disabled={disabled}
				>
					<img
						src="/assets/icons/confirm-icon.svg"
						alt="Close Icon"
						className="w-[18px] h-[18px]"
					/>
				</button>
			</Tooltip>
			<Tooltip title="Cancel">
				<button
					disabled={disabled}
					className={`
                      !w-[40px] h-[40px] p-[10px] pl-[11px] border-transparent border-[1px] 
                      hover:shadow-sm hover:border-[#ECEDEF] hover:border-[1px] 
                      focus:shadow-sm focus:border-[#ECEDEF] focus:border-[1px] cancel
                       ${disabled && 'cursor-progress'}
                    `}
					onClick={handleCancel}
				>
					<img
						src="/assets/icons/Close.svg"
						alt="Close Icon"
						className="w-[18px] h-[18px]"
					/>
				</button>
			</Tooltip>
		</>
	);
};

export default ConfirmationButtons;
